import Box from '@mui/system/Box';
import * as React from 'react';
import { ReactElement, ReactNode } from 'react';

type GroupProps = {
    children: ReactNode;
};

const Group = ({ children }: GroupProps) => {
    const array = React.Children.toArray(children);
    const childLength = array.length;

    const childrenWithProps = React.Children.map(children, (child, index) => {
        let outline: string;

        if (React.isValidElement(child)) {
            // valid element
        }
        if (childLength < 2) {
            outline = 'single';
        } else if (index === 0) {
            outline = 'top';
        } else if (index === childLength - 1) {
            outline = 'bottom';
        } else {
            outline = 'middle';
        }

        return React.cloneElement(child as ReactElement, { outline } as any, null);
    });

    return <Box style={{ margin: '10px 0' }}>{childrenWithProps}</Box>;
};

export default Group;
